module.exports = __webpack_public_path__ + "static/media/USPCommunity.5bd1af2c.png";